// extracted by mini-css-extract-plugin
export var container = "_f6-1";
export var cornerButtonContainer = "_f6-6";
export var disabled = "_f6-2";
export var dragActive = "_f6-3";
export var fileContainer = "_f6-5";
export var hiddenInput = "_f6-4";
export var widthContainer = "_f6-0";